import React, { useEffect, useState } from "react";
import "./ProfileImageComponent.css";
import { Buffer } from "buffer";
import { Camera, Phone } from "lucide-react";
import { useDispatch } from "react-redux";
import { fetchProfileData } from "../../../CentralStore/ExportLMSTable/dataSlice";
import { updateProfileImage } from "../../../Services/EndPoints";
import { putDataFormDataWithNoidPf } from "../../../Services/ProfileServices";
import lmsToast from "../../DMS/Common/CustomToastifier/CustomToastifier";
import { useTranslation } from "react-i18next";
import DmsButton from "../../DMS/Common/DmsButton/DmsButton";
import avatar from "../../../Assets/Images/avatar.png";
export default function ProfileImageComponent({ profileData }) {
  const dispatch = useDispatch();
  const [fileObj, setFileObj] = useState(null);
  const [imgSrc, setImgSrc] = useState(avatar); // Set default avatar initially
  const [errorMsg, setErrorMsg] = useState("");
  const { t } = useTranslation();

  useEffect(() => {
    if (profileData?.user_image) {
      setImgSrc(`data:image/jpeg;base64,${profileData.user_image}`);
    } else {
      setImgSrc(avatar); // Fallback to the default avatar if no user image
    }
  }, [profileData]);

  const validFileTypes = ["image/png", "image/jpg", "image/jpeg"];
  const handleChange = (event) => {
    const file = event.target.files[0];
    if (file && validFileTypes.includes(file.type)) {
      if (file.size < 15000000) {
        setFileObj(file);

        const reader = new FileReader();
        reader.onload = () => {
          // Strip the "data:image/...;base64," prefix — API expects raw base64 only.
          const base64Image = reader.result.split(",")[1];
          const formData = new FormData();
          formData.append(
            "user_profile",
            JSON.stringify({ id: profileData?.id, user_image: base64Image })
          );
          putDataFormDataWithNoidPf(updateProfileImage, formData)
            .then((res) => {
              setTimeout(() => {
                lmsToast({
                  toasterType: "success",
                  msg: "Successfully Profile Picture Changed",
                });
              }, 200);
              dispatch(fetchProfileData());
            })
            .catch((err) => {
              console.log(err);
            });
        };
        reader.readAsDataURL(file);

        setErrorMsg("");
      }
    } else {
      setErrorMsg("Invalid file type. Please select an image.");
    }
  };

  const handleClick = () => {
    const fileInputTriger = document.getElementById("file_upload");
    if (fileInputTriger) {
      fileInputTriger.click();
    }
  };

  return (
    <div className="image_container--maindiv">
      <div className="profile_image">
        <img
          src={imgSrc}
          className="profile_image--image"
          onError={(e) => {
            e.target.src = avatar; // Fallback to default avatar on error
          }}
        />
        <div className="edit-profile_icon">
          <DmsButton
            className="up-camera-btn"
            style={{
              width: "32px",
              height: "32px",
              minWidth: "32px",
              padding: 0,
              borderRadius: "50%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              backgroundColor: "#2b6591",
              border: "3px solid #fff",
              boxShadow: "0 2px 6px rgba(0,0,0,0.25)",
            }}
            label={<Camera size={14} color="#fff" />}
            title={t("editphoto")}
            onClick={handleClick}
          />
          <input
            id="file_upload"
            type="file"
            accept="image/*"
            name="file_upload"
            style={{ display: "none" }}
            onChange={(event) => {
              handleChange(event);
            }}
          />
        </div>
      </div>
      {errorMsg && <div className="error__message w-100">{errorMsg}</div>}
      <div className="user-profile_detail">
        <div className="up-name">
          {`${profileData?.first_name || ""} ${
            profileData?.middle_name ? profileData?.middle_name : ""
          } ${profileData?.last_name || ""}`.replace(/\s+/g, " ").trim()}
        </div>
        <div className="up-username">{profileData?.user_name}</div>
        {profileData?.phone_number && (
          <div className="up-phone-pill">
            <Phone size={12} /> {profileData.phone_number}
          </div>
        )}
      </div>
    </div>
  );
}
